import React from 'react';
import '../../css/style.css';
import 'react-bootstrap/dist/react-bootstrap';




function Preloader() {
    return (
      <div className="preloader">
        <img 
          src="/assets/img/spinner.svg" 
          alt="Loading…" 
          className="preloader__spinner"
          width="100"
          height="100"
        />
      </div>
    )
  }
  
  export default Preloader;